import { choose } from '../../utils/platform';
import QuickAddDesktop from './QuickAdd.desktop';
import QuickAddMobile from './QuickAdd.mobile';

export default choose(QuickAddDesktop, QuickAddMobile);
